module.exports = __webpack_public_path__ + "static/img/ent-detail-80.36b5c04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-80.jpg
// module id = k1qY
// module chunks = 51